import React from "react";
import { Box, Button, Typography } from "@mui/material";
import "./pagination-component-new.scss";
import { PaginationProps } from "./pagination-component-props";

export default function PaginationComponentNew({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps) {
  return (
    <Box className="pagination-container">
      <Button
        className="pagination-button"
        variant="outlined"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        Prev
      </Button>

      <Typography className="pagination-info">
        Page <span className="current-page">{currentPage}</span> of {totalPages}
      </Typography>

      <Button
        className="pagination-button"
        variant="outlined"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        Next
      </Button>
    </Box>
  );
}
